<table class="simple-table m-t-20">
  <tr>
    <th>Lower Ownership</th>
    <th>Upper Ownership</th>
    <th>Lower Holding Period</th>
    <th>Upper Holding Period</th>
    <th>{{data.input.header}}</th>
  </tr>
  <tr *ngFor="let row of data.input.data">
    <td>
      {{row.lowerHolding}}
    </td>
    <td>
      {{row.upperHolding}}
    </td>
    <td>
      {{row.lowerHoldingPeriod}}
    </td>
    <td>
      {{row.upperHoldingPeriod === -1 ? '' : row.upperHoldingPeriod}}
    </td>
    <td>
      {{row.rate}}
    </td>
  </tr>
</table>
